import closeIcon from './images/关闭.png'
import courierIcon from './images/派送中.png'
import doingIcon from './images/完成.png'
import locationIcon from './images/位置.png'
import orderStateIcon from './images/待签收.png'
import phoneIcon from './images/电话.png'

export default {
  locationIcon: locationIcon,
  orderStateIcon: orderStateIcon,
  phoneIcon: phoneIcon,
  courierIcon: courierIcon,
  doingIcon: doingIcon,
  closeIcon: closeIcon,
}
